export default {
  FETCH_FINANCIAL_TRANSACTIONS_SUCCESS: 'FETCH_FINANCIAL_TRANSACTIONS_SUCCESS',
  FETCH_FINANCIAL_TRANSACTIONS_LOADING: 'FETCH_FINANCIAL_TRANSACTIONS_LOADING',
  FETCH_FINANCIAL_TRANSACTIONS_REJECT: 'FETCH_FINANCIAL_TRANSACTIONS_REJECT',
  FETCH_FINANCIAL_TRANSACTIONS_FAILED: 'FETCH_FINANCIAL_TRANSACTIONS_FAILED',

  FETCH_FINANCIAL_TRANSACTION_DETAILS_LOADING: 'FETCH_FINANCIAL_TRANSACTION_DETAILS_LOADING',
  FETCH_FINANCIAL_TRANSACTION_DETAILS_FAILED: 'FETCH_FINANCIAL_TRANSACTION_DETAILS_FAILED',
  FETCH_FINANCIAL_TRANSACTION_DETAILS_SUCCESS: 'FETCH_FINANCIAL_TRANSACTION_DETAILS_SUCCESS',
  FETCH_FINANCIAL_TRANSACTION_DETAILS_REJECT: 'FETCH_FINANCIAL_TRANSACTION_DETAILS_REJECT',

  FETCH_USER_FINANCIAL_TRANSACTIONS_SUCCESS: 'FETCH_USER_FINANCIAL_TRANSACTIONS_SUCCESS',
  FETCH_USER_FINANCIAL_TRANSACTIONS_LOADING: 'FETCH_USER_FINANCIAL_TRANSACTIONS_LOADING',
  FETCH_USER_FINANCIAL_TRANSACTIONS_REJECT: 'FETCH_USER_FINANCIAL_TRANSACTIONS_REJECT',
  FETCH_USER_FINANCIAL_TRANSACTIONS_FAILED: 'FETCH_USER_FINANCIAL_TRANSACTIONS_FAILED',

  GET_CONSTANT_RESERVES_REPORT_LOADING: 'GET_CONSTANT_RESERVES_REPORT_LOADING',
  GET_CONSTANT_RESERVES_REPORT_SUCCESS: 'GET_CONSTANT_RESERVES_REPORT_SUCCESS',
  GET_CONSTANT_RESERVES_REPORT_REJECT: 'GET_CONSTANT_RESERVES_REPORT_REJECT',
  GET_CONSTANT_RESERVES_REPORT_FAILED: 'GET_CONSTANT_RESERVES_REPORT_FAILED',

  GET_RECHARGE_CHAIRS_REPORT_LOADING: 'GET_RECHARGE_CHAIRS_REPORT_LOADING',
  GET_RECHARGE_CHAIRS_REPORT_SUCCESS: 'GET_RECHARGE_CHAIRS_REPORT_SUCCESS',
  GET_RECHARGE_CHAIRS_REPORT_REJECT: 'GET_RECHARGE_CHAIRS_REPORT_REJECT',
  GET_RECHARGE_CHAIRS_REPORT_FAILED: 'GET_RECHARGE_CHAIRS_REPORT_FAILED',

  GET_PURCHASE_PACKAGES_REPORT_LOADING: 'GET_PURCHASE_PACKAGES_REPORT_LOADING',
  GET_PURCHASE_PACKAGES_REPORT_SUCCESS: 'GET_PURCHASE_PACKAGES_REPORT_SUCCESS',
  GET_PURCHASE_PACKAGES_REPORT_REJECT: 'GET_PURCHASE_PACKAGES_REPORT_REJECT',
  GET_PURCHASE_PACKAGES_REPORT_FAILED: 'GET_PURCHASE_PACKAGES_REPORT_FAILED',
};
